// extracted by mini-css-extract-plugin
export default {"bgc":"UpdateBook_bgc__x6Jhq","title":"UpdateBook_title__n4ROO","wrapper":"UpdateBook_wrapper__Z6e8F","back":"UpdateBook_back__eCM11"};